import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Images } from "../../../../assets/assets";
import "./earthwork.css";
import { useEarthWorkStore } from "../../../../store/useEarthWorkStore";
import { useState } from "react";
import Loader from "../../../Loader";

export default function EarthworkServices() {
    const { getEarthWork, earthwork } = useEarthWorkStore()
    const [loading, setLoading] = useState(false)

    const getFetchedEartWork = async () => {
        setLoading(true)
        await getEarthWork(1, 5, '', '')
        setLoading(false)
    }

    useEffect(() => {
        if (earthwork.length > 0)
            return
        getFetchedEartWork()
    }, [])
    return (
        <div className="earthworkservices-page mt-5">
            <Loader loading={loading}>
                {
                    (earthwork || []).map((item, i) => {
                        return (
                            <section className="earthworkservices-section1 py-5 mb-xl-4 mb-3" key={i}>
                                <Container className="theme-container">
                                    <Row className={`service-block align-items-center ${i % 2 !== 0 && `flex-lg-row-reverse`}`}>
                                        <Col lg={6}>
                                            <p className="section-subtitle">{item?.subTitle}</p>
                                            <h4 className="title mb-xl-4 mb-3">{item?.title}</h4>
                                            <p className="mb-xl-4 mb-3">
                                                {item?.description?.split("\n").map((line, idx) => (
                                                    <span key={idx}>
                                                        {line} <br />
                                                    </span>
                                                ))}
                                            </p>
                                        </Col>
                                        <Col lg={6}>
                                            <div className="img-wrapper">
                                                <div className="img-wraper-2">
                                                    <img className="img-fluid" src={item?.image} alt="earth work image" />
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </section>
                        )
                    })
                }
            </Loader>
            {/* <section className="earthworkservices-section2 bg-light-gray py-5 mb-xl-4 mb-3">
                <Container className="theme-container">
                    <Row className="service-block flex-lg-row-reverse align-items-center">
                        <Col lg={6}>
                            <p className="section-subtitle">LET US LEVEL WITH YOU</p>
                            <h4 className="title mb-xl-4 mb-3">Mass Grading</h4>
                            <p className="mb-xl-4 mb-3">
                                Mass grading is the precise delivery and balancing of cut/fill aggregates to meet exact elevation
                                plans across the site to create functional pads. Our powerful dozers move the earth, then scrapers
                                work on cross sections & blades maintain grade. Combined, finish grading is specialized to
                                municipal, commercial & industrial specs.
                            </p>
                            <p>
                                Using laser or global GPS-controlled machinery, our grading systems perform to precision just as
                                the earthmoving process commences. So, whether your site is densely populated and has underground
                                lines or sensitive trees and topsoil, our site is fully prepared and safe to achieve required cut,
                                import, and export per density.
                            </p>
                        </Col>
                        <Col lg={6}>
                            <div className="img-wrapper">
                                <img className="img-fluid" src={Images.Earthworkimg2} alt="earth work image" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="earthworkservices-section3 py-5 mb-xl-4 mb-3">
                <Container className="theme-container">
                    <Row className="service-block align-items-center">
                        <Col lg={6}>
                            <p className="section-subtitle">FINISHING WHAT WE STARTED</p>
                            <h4 className="title mb-xl-4 mb-3">Fine Grading</h4>
                            <p className="mb-xl-4 mb-3">
                                Fine grading is the process levelling and contouring of cut/fill aggregates to new roads and
                                elevations in preparation of underground service placements. Hardened steel cutters aggregate is
                                removed and mud lines removed.
                            </p>
                            <p>
                                Using laser or GPS-controlled machinery, we can achieve smooth operations. Our process is
                                cost-effective, repeatable, accurate. Every construction site needs to work from a flat operable
                                grade to ensure easier movement and access to municipal, commercial, and residential site services.
                            </p>
                        </Col>
                        <Col lg={6}>
                            <div className="img-wrapper">
                                <div className="img-wraper-2">
                                    <img className="img-fluid" src={Images.Earthworkimg3} alt="earth work image" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

 
            <section className="earthworkservices-section4 bg-light-gray py-5 mb-xl-4 mb-3">
                <Container className="theme-container">
                    <Row className="service-block flex-lg-row-reverse align-items-center">
                        <Col lg={6}>
                            <p className="section-subtitle">GRADING</p>
                            <h4 className="title mb-xl-4 mb-3">Erosion Control</h4>
                            <p className="mb-xl-4 mb-3">
                                Erosion control is a critical component of land construction, designed to prevent water movement
                                and soil loss. Our company specializes in stabilizing disturbed soil to preserve construction
                                surfaces and comply with industry stormwater & environmental standards.
                            </p>
                            <p>
                                Our erosion control services include the installation and maintenance of sheet barriers, silt
                                fencing, tackifier products, and straw wattles. We tailor our sites for each location’s specific
                                sediment control types, flow rate pipelines, and local regulatory requirements.
                            </p>
                        </Col>
                        <Col lg={6}>
                            <div className="img-wrapper">
                                <div className="img-wraper-2">
                                    <img className="img-fluid" src={Images.Earthworkimg4} alt="earth work image" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
   
            <section className="earthworkservices-section5 py-5 mb-xl-4 mb-3">
                <Container className="theme-container">
                    <Row className="service-block align-items-center">
                        <Col lg={6}>
                            <p className="section-subtitle">MOVING EARTH. MAKING PROGRESS</p>
                            <h4 className="title mb-xl-4 mb-3">Excavation & Fill</h4>
                            <p className="mb-xl-4 mb-3">
                                Excavation and fill are essential to completing a site grade. Suitable sites require extensive
                                cut-and-fill operations as excavation is carried out simultaneously as trucks carry, place, and
                                compact earth.Our specialized excavations teams are experienced in both.
                            </p>
                            <p className="mb-xl-4 mb-3">
                                Fill operations utilize the latest ground compaction and levelling machines to ensure structural
                                integrity. High compaction rates mean minimal settlement and longevity in the future build.
                            </p>
                            <p>Site balancing is available upon request to reduce the need for hauling material off-site. With GPS-guided equipment and skilled crews, we deliver excavation and fill services with precision, safety, and efficiency.</p>
                        </Col>
                        <Col lg={6}>
                            <div className="img-wrapper">
                                <div className="img-wraper-2">
                                    <img className="img-fluid" src={Images.Earthworkimg5} alt="earth work image" />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}
        </div>
    );
}
